import { Box, Button, Container, Grid, Typography } from '@mui/material';
import axios from 'axios';
import React, { useEffect, useState } from 'react'
import { Link, useParams } from 'react-router-dom';
import { Divider } from 'semantic-ui-react';
import { API_URL, APP_URL } from '../../../Config';
import LikeButton from '../../Like/likebutton';
import { BoMainV } from '../CateCs';
import notrevealed from '../../../images/notrevealed.jpg';

const Categoriesdetails = () => {
    const [Fetchdata, setfetchedata] = useState([]);
    const {category} =useParams();
  
    const Fetchnft = async () => {
        
        await axios
            .post(`${API_URL}/fetchCategory.php?type=category&category=${category}`, {
                headers: {
                    "Content-Type": "application/json",
                },
            })
            .then(async (req) => {
                if (req.data) {
                    setfetchedata(req.data);
                }
            })
    };

    useEffect(() => {
        if (Fetchdata.length == 0) {
            Fetchnft();
        }
    }, [Fetchdata]);
    return (
        <div>
            <Box className='contact_us'>
                <Box className='createcollection_bg'>
                    <Typography variant='h2' fontWeight='600' fontSize='45px'>
                        Categories Details
                    </Typography>
                </Box>
            </Box>
            
            <Box className="collection_details">
                <Container maxWidth='xl'>
                    <Grid container spacing={1}>
                        {Fetchdata && Fetchdata.map((token, idx) => (
                            <Grid key={idx} item lg={3} sm={4} md={4} xs={12} marginBottom='30px'>
                                <BoMainV className='ContenMain'>
                                <Link to={`/Buydetails/${token.NFT_id}`}>
                                 {token.NFT_image.split('.').pop()== "png" ||token.NFT_image.split('.').pop()=='jpg'||token.NFT_image.split('.').pop()=='jpeg'?
                                    <img src={token.Private==0 ? APP_URL+'/'+token.NFT_image:notrevealed} width='100%' className='base_pht' style={{ borderRadius: '5px' }} /> 
                                    :token.NFT_image.split('.').pop()== "mp4" ?
                                    <video width="750" height="500" controls >
                                        <source src={token.Private==0 ? APP_URL+'/'+token.NFT_image:notrevealed} type="video/mp4"/>
                                    </video>
                                    :token.NFT_image.split('.').pop()== "mp3" ||token.NFT_image.split('.').pop()=='aac'?
                                    <audio controls>
                                    <source src={token.Private==0 ? APP_URL+'/'+token.NFT_image:notrevealed} type="audio/mpeg"/>
                                    Your browser does not support the audio tag.
                                    </audio> 
                                    :<img src={token.Private==0 ? APP_URL+'/'+token.NFT_image:notrevealed} width='100%' style={{ borderRadius: '5px' }} />
                                    } 
                                </Link>
                                   <Box display='flex' justifyContent='space-between' paddingY='10px'>
                                        <Box>
                                        <Typography fontWeight='600' fontSize='22' variant='h6' color='#000'>
                                            <Link to={`/Buydetails/${token.NFT_id}`}>
                                                {token.Private ==0?token.NFT_name:"SECRET NFT"}
                                                </Link>
                                            </Typography>
                                        </Box>
                                        <Box>
                                            <LikeButton nft={token} />  
                                        </Box>
                                    </Box>
                                    <Divider/>
                                    <Box>
                                        <Box>
                                            <Typography variant='h5' color='#000' fontWeight='600' fontSize='16px'>
                                                Reserve Price
                                            </Typography>
                                            <Typography fontWeight='500' variant='h6' fontSize='15px' color='#000'>
                                                {token.NFT_price} {token.NFT_payment}
                                            </Typography>
                                        </Box>
                                    </Box>
                                </BoMainV>
                            </Grid>
                        ))}
                    </Grid>
                </Container>
            </Box>
        </div>
    )
}

export default Categoriesdetails; 